<template>
  <div class="wait-loading">
    <div v-show="!isLoading" class="netError-icon">
      <i class="iconfont icon-Icon_No_Network_" style="font-size:128px;color:#EAEDF0"></i>
    </div>
    <div v-show="!isLoading" class="netError-text">Data failed loading.Please reload</div>
    <div v-show="!isLoading" class="netError-btn-con">
      <div class="netError-btn" @click="reload()">Reload</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  inject: ["showMask", "shutMask"],
  props: {},
  components: {
  },
  data() {
    return {
      isLoading: false,
      country: "ke"
    };
  },
  mounted() {
    this.shutMask();
  },
  computed: {},
  watch: {},
  created() {

  },
  methods: {
    reload() {
      let params = {};
      let user = this.$store.getters['userInfo'];
      user.token && (params.token = encodeURIComponent(user.token));
      user.secretKey && (params.secretKey = encodeURIComponent(user.secretKey));
      let platfrom = this.$store.getters['getPlatfrom'];
      platfrom && (params.platfrom = platfrom);
      let country = this.$store.getters['country'];
      country && (params.country = country);
      let uri = "";
      for (let key in params) {
          (uri != "") && (uri += "&");
          uri += key + "=" + params[key];
      }
      let url = window.location.href.split("#")[0] + "#/?" + uri;
      window.location.href = url;
    }
  }
};
</script>

<style scoped>
.wait-loading {
  width: 100%;
  height: 100%;
}

.netError-icon {
  margin-top: 100px;
  width: 100%;
  height: 128px;
  line-height: 128px;
  text-align: center;
}
.netError-text {
  width: 100%;
  height: 70px;
  line-height: 70px;
  text-align: center;
  color: #adb0bb;
}
.netError-btn-con {
  width: 100%;
  height: 72px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.netError-btn {
  width: 180px;
  height: 72px;
  background: #10a310;
  border-radius: 36px;
  text-align: center;
  font-size: 26px;
  color: #ffffff;
  line-height: 72px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Loading/index.vue